import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentProps } from "react";
import { cn } from "../../lib/cn";

/** Every tone is a container pair, so contrast holds in both colour modes. */
export const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-control px-2.5 py-0.5 font-display text-xs font-semibold whitespace-nowrap",
  {
    variants: {
      tone: {
        accent: "bg-accent-container text-on-accent-container",
        success: "bg-success-container text-on-success-container",
        warning: "bg-warning-container text-on-warning-container",
        danger: "bg-danger-container text-on-danger-container",
        info: "bg-info-container text-on-info-container",
        system: "bg-system-container text-on-system-container",
        neutral: "bg-neutral-container text-on-neutral-container",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

export type BadgeTone = NonNullable<VariantProps<typeof badgeVariants>["tone"]>;

export interface BadgeProps extends ComponentProps<"span">, VariantProps<typeof badgeVariants> {}

export function Badge({ tone, className, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
